import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AdminService } from 'src/app/services/admin.service';
import { LoaderService } from 'src/app/services/loader.service';

//type CDSRequestViewModelWithDisplay = ServerModels.CDSRequestViewModel & { StatusDisplay, Action, StateDateDisplay }

@Component({
  selector: 'agency-cds-dialog.component',
  templateUrl: './agency-cds-dialog.component.html',
  styleUrls: ['./agency-cds-dialog.component.scss']
})
export class AgencyCDSDialogComponent implements OnInit {

  private _unsubscribe$: Subject<void> = new Subject<void>();

  data: any = null;
  confirmHeader: string = null;
  confirmMessage: string = null;
  action: string = null;
  dtnDisplayName: string = 'Confirm';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private loaderService: LoaderService,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.resetDialog()
    this.confirmMessage = this.config.data['message'].toString();
    this.data = this.config.data['data'];
    this.action = this.config.data['action'].toString();
    this.dtnDisplayName = this.config.data['dtnDisplayName'].toString();
  }

  ngOnDestroy() {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public onConfirmSubmit(value: string) {
    switch (value) {
      case 'Cancel': {
        this.ref.close(null);
        break;
      }
      case 'Approve': {
        this.execAction(this.action);
        break;
      }
    }
  }

  private execAction(action: string) {
    switch (action) {
      case 'Approve': {
        this.ref.close(this.data);
        break;
      }
      case 'Request': {
        this.ref.close(this.data);
        break;
      }
      case 'Confirm': {
        this.ref.close(this.data);
        break;
      }
    }
  }

  private resetDialog(): void {
    this.confirmMessage = null;
    this.data = null;
    this.action = null;
  }
}
